export default function useAssets(type = true) {
  // 是否是common文件里调用
  const modules: Record<string, string> = {};
  let pictures: any;
  if (!type) {
    pictures = import.meta.glob(`/src/images/**/*`, { eager: false });
  } else {
    pictures = import.meta.glob(`../images/kaka/**/*`, { eager: false });
  }
  Object.keys(pictures).forEach((key) => {
    if (!type) {
      modules[key.replace(/^(\/src\/images\/)(\S+)(\.\/|\.(png|gif))/g, '$2')] =
        pictures[key].default;
      // pictures = import.meta.globEager(`/src/images/**/*`);
    } else {
      modules[key.replace(/^(\.\.\/images\/kaka\/)(\S+)(\.\/|\.(png|gif))/g, '$2')] =
        pictures[key].default;
    }
  });
  return modules;
}
